import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';

import * as fromSchoolSearch from './reports-school-search.reducer';
import * as fromSearchResults from './reports-school-searchresults.reducer';
import * as fromPrefsResults from './report-pref.reducer';

export interface ReportsSearchState {
  schoolSearch: fromSchoolSearch.ReportsSchoolSearchState;
} 

export interface ReportsSchoolsState {
  search: fromSearchResults.ReportsSearchResultsState;
}
export interface ReportPrefsResultsState {
  prefs: fromPrefsResults.ReportPrefsSearchResultsState,
}

export const reducers: ActionReducerMap<ReportsSearchState> = {
  schoolSearch: fromSchoolSearch.reducer,
};

export const reducersSchool: ActionReducerMap<ReportsSchoolsState> = {
  search: fromSearchResults.reducer,
};

export const reducersPrefs: ActionReducerMap<ReportPrefsResultsState> = {
  prefs: fromPrefsResults.reducer,
};

export const getReportsSearchState = createFeatureSelector<ReportsSearchState>('reportSearch');
export const getReportsSchoolsState = createFeatureSelector<ReportsSchoolsState>('reportSchools');
export const getReportsPrefsState = createFeatureSelector<ReportPrefsResultsState>('prefs');

export { ReportsSchoolSearchState } from './reports-school-search.reducer';
export { ReportsSearchResultsState, initialState } from './reports-school-searchresults.reducer';
export { ReportPrefsSearchResultsState } from './report-pref.reducer';
